/** English catalog keys for words finance builds from data. The contract lists them so they are always translated. */
import type { CategoryType, DocState } from "./types";

export const STATUS_FILTER_LABELS = { all: "All", unpaid: "Unpaid", overdue: "Overdue", needs_look: "Needs a look", draft: "Drafts", void: "Void" } as const;

export const HISTORY_ACTION_LABELS: Record<string, string> = {
  create: "Recorded", edit: "Changed", post: "Finished the draft", void: "Voided", payment: "Payment recorded", unpay: "Payment removed", apply: "Matched to a bill",
  unapply: "Unmatched", allocate: "Shares changed", link: "Linked", unlink: "Unlinked", receive: "Received into supplies", unreceive: "Taken back out of supplies",
};

export const HISTORY_FIELD_LABELS: Record<string, string> = {
  kind: "Kind", status: "Status", contact_id: "Who", doc_date: "Date", due_date: "Due", number: "Number", currency: "Currency", total_minor: "Total", memo: "Note", attrs: "How paid", lines: "Lines",
};

export const STATEMENT_ENTRY_LABELS = { charge: "Their share of a cost", credit: "Their share of income", payment_in: "Payment from them", payment_out: "Payment to them" } as const;

export const DOC_STATE_LABELS: Record<DocState, string> = { draft: "Draft", void: "Void", settled: "Settled", open: "Open", partial: "Partly paid", paid: "Paid" };

export const CATEGORY_TYPE_LABELS: Record<CategoryType, string> = { income: "Income", expense: "Expenses", other: "Not profit or loss" };

export const ACCOUNTING_COLUMNS = ["Date", "Type", "Number", "Contact", "Account", "Account code", "Schedule F line", "Description", "Amount", "Currency", "Class", "Due date", "Status", "Memo", "Hondo record", "Hondo line"];

export const LEDGER_COLUMNS = [
  "Hondo record", "Hondo line", "Date", "Kind", "Status", "Number", "Contact", "Due date", "Memo", "Description", "Category", "Category type", "Quantity", "Unit",
  "Line amount", "Currency", "Record total", "Paid", "Still owed", "Enterprises", "Cattle", "Owners", "Applies to", "Source", "Links",
];

export const LABEL_MESSAGES: string[] = [
  ...Object.values(STATUS_FILTER_LABELS), ...Object.values(HISTORY_ACTION_LABELS), ...Object.values(HISTORY_FIELD_LABELS), ...Object.values(STATEMENT_ENTRY_LABELS),
  ...Object.values(DOC_STATE_LABELS), ...Object.values(CATEGORY_TYPE_LABELS), ...ACCOUNTING_COLUMNS, ...LEDGER_COLUMNS, "Money", "Purchases",
];
